var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSenderSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.83203C0 10.6025 3.06152 13.6533 6.83203 13.6533C8.28223 13.6533 9.61426 13.2021 10.7207 12.4287L14.7168 16.4355C14.9424 16.6504 15.2217 16.7471 15.5117 16.7471C16.1348 16.7471 16.5859 16.2744 16.5859 15.6514C16.5859 15.3506 16.4678 15.082 16.2852 14.8779L12.3105 10.8926C13.1592 9.75391 13.6533 8.35742 13.6533 6.83203C13.6533 3.06152 10.6025 0 6.83203 0C3.06152 0 0 3.06152 0 6.83203ZM1.6543 6.83203C1.6543 3.96387 3.96387 1.6543 6.83203 1.6543C9.68945 1.6543 12.0098 3.96387 12.0098 6.83203C12.0098 9.68945 9.68945 12.0098 6.83203 12.0098C3.96387 12.0098 1.6543 9.68945 1.6543 6.83203Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98535 6.83203C3.98535 7.21875 4.29688 7.53027 4.69434 7.53027H6.12305V8.95898C6.12305 9.35645 6.43457 9.66797 6.83203 9.66797C7.21875 9.66797 7.53027 9.35645 7.53027 8.95898V7.53027H8.95898C9.35645 7.53027 9.66797 7.21875 9.66797 6.83203C9.66797 6.43457 9.35645 6.12305 8.95898 6.12305H7.53027V4.69434C7.53027 4.29688 7.21875 3.98535 6.83203 3.98535C6.43457 3.98535 6.12305 4.29688 6.12305 4.69434V6.12305H4.69434C4.29688 6.12305 3.98535 6.43457 3.98535 6.83203Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSenderSearchIcon);
export default __webpack_public_path__ + "static/media/add_sender_search_icon.6ce72d0b5b4d11604674c6e6542b2628.svg";
export { ForwardRef as ReactComponent };